exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1QL_3lofZIKeUDU4QFZO52{height:100%}._1B4dUcxPkcQDBrinZaXRZz{position:absolute;bottom:0;width:100%}", ""]);
// Exports
exports.locals = {
	"boardContainer": "_1QL_3lofZIKeUDU4QFZO52",
	"devDeleteButton": "_1B4dUcxPkcQDBrinZaXRZz"
};